import { useCallback, useMemo } from 'react';
import { useAppDispatch } from '..';
import { updateNavItemBookmarkState } from '../../reducers/navItems';
export const useNavBookmarks = () => {
  const dispatch = useAppDispatch();
  const addNavItemToBookmarks = useCallback(input => {
    dispatch(updateNavItemBookmarkState({
      id: input.id,
      isBookmarked: true
    }));
  }, [dispatch]);
  const removeNavItemFromBookmarks = useCallback(id => {
    dispatch(updateNavItemBookmarkState({
      id,
      isBookmarked: false
    }));
  }, [dispatch]);
  return useMemo(() => ({
    addNavItemToBookmarks,
    removeNavItemFromBookmarks
  }), [addNavItemToBookmarks, removeNavItemFromBookmarks]);
};